import {Table} from 'antd';
import {useContext, useMemo} from 'react';

import {useLocale} from '../../../../../../../provider/locale/locale-hook';
import {MainFilterContext} from '../../../../../../../provider/main-filter/main-filter';
import {MainFilterContextType} from '../../../../../../../provider/main-filter/main-filter-type';
import {useUserTags} from '../../../../../../../service/reivew-analysis/review-analytics-tags/review-analytics-tag-hook';
import {ReviwsAnalysisUserTagTableDataType} from '../../../../../../../service/reivew-analysis/review-analytics-tags/review-analytics-tags-type';
import {ReviewsAndAnswersStatisticsUnitMeasurementEnum} from '../../../../../../../service/reviews-and-answers-statistics/reviews-and-answers-statistics';
import {getRangeFilterTagFormat} from '../../../../reviews-analysis-helper';
import {useReviewsAnalysisFilter} from '../../../../reviews-analysis-hook';
import {ReviewsAnalysisFilterEnum} from '../../../../reviews-analysis-type';
import {mergeCompareData, userTagsPageTableColumns} from '../../keywords-and-topics-page-helper';

export function UserTagsTablePeriod(): JSX.Element {
    const {getLocalizedString, localeName} = useLocale();
    const {mainFilterKey} = useContext<MainFilterContextType>(MainFilterContext);

    const {filter, singleFilter, comparePeriodFilter} = useReviewsAnalysisFilter();

    const {data: singleData, isLoading: isSingleLoading} = useUserTags(singleFilter, mainFilterKey);
    const {data: compareData, isLoading: isCompareLoading} = useUserTags(comparePeriodFilter, mainFilterKey);

    const compareRange: [Date | null, Date | null] = filter[ReviewsAnalysisFilterEnum.CompareRange];
    const comparePeriod: string = useMemo(
        () => getRangeFilterTagFormat(localeName, compareRange),
        [localeName, compareRange]
    );

    const dataSource: Array<ReviwsAnalysisUserTagTableDataType> = useMemo(() => {
        return mergeCompareData(
            singleData?.results || [],
            compareData?.results || [],
            getLocalizedString('REVIEWS_ANALYSIS__DASHBOARD__COMPARE_PERIOD_NAME', {period: comparePeriod})
        );
    }, [singleData, compareData, getLocalizedString, comparePeriod]);

    return (
        <Table<ReviwsAnalysisUserTagTableDataType>
            columns={userTagsPageTableColumns({
                timeUnit: singleFilter.timeFormat || ReviewsAndAnswersStatisticsUnitMeasurementEnum.Minutes,
            })}
            dataSource={dataSource}
            loading={isSingleLoading || isCompareLoading}
            scroll={{x: true}}
            size="middle"
        />
    );
}
